// @flow

export const UPLOAD_INIT = 'UPLOAD_INIT'
export const UPLOAD_START = 'UPLOAD_START'
export const UPLOAD_SUCCESS = 'UPLOAD_SUCCESS'
export const UPLOAD_ERROR = 'UPLOADERROR'

export const actionTypes = {
  UPLOAD_INIT,
  UPLOAD_START,
  UPLOAD_SUCCESS,
  UPLOAD_ERROR,
}

type Payload = {
  bucket: string,
  blob: string,
  description: string,
  upload: Object,
  error: Object,
}

export function uploadInit() {
  return {
    type: UPLOAD_INIT,
  }
}

export function uploadStart(bucket: string, blob: string, description: string) {
  return {
    type: UPLOAD_START,
    payload: {
      bucket,
      blob,
      description,
    },
  }
}

export function uploadSuccess(upload: Object) {
  return {
    type: UPLOAD_SUCCESS,
    payload: {
      upload,
    },
  }
}

export function uploadError(error: Object) {
  return {
    type: UPLOAD_ERROR,
    payload: {
      error,
    },
  }
}

export const actions = {
  init: uploadInit,
  start: uploadStart,
  success: uploadSuccess,
  error: uploadError,
}

export function getUploadStatus(state: { icons: Object }) {
  return state.icons.creation.status
}

export function getUploadError(state: { icons: Object }) {
  return state.icons.creation.error
}

const initialState = {
  status: 'initialized',
}

export default function reducer(
  state: Object = initialState,
  { type, payload }: { type: string, payload: Payload }
) {
  switch (type) {
    case UPLOAD_INIT:
      return initialState
    case UPLOAD_START:
      const { bucket, blob, description } = payload
      return {
        status: 'uploading',
        bucket,
        blob,
        description,
      }
    case UPLOAD_SUCCESS:
      const { upload } = payload
      return {
        ...state,
        status: 'success',
        upload,
      }
    case UPLOAD_ERROR:
      const { error } = payload
      return {
        status: 'error',
        error,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/stores/upload/index.js